/**
 * Shared bits of the admin Turn Detail page, extracted so the per-tab
 * components (TurnActionsTab, TurnOutputsTab, ...) and the container can use
 * them without circular imports — and so they stay unit-testable in node.
 */

export type TabId = "overview" | "actions" | "outputs" | "context" | "error";

export const validTabs: TabId[] = ["overview", "actions", "outputs", "context", "error"];

export function getFeedbackIcon(thumbsUp: boolean, thumbsDown: boolean): string {
  if (thumbsUp) return "👍";
  if (thumbsDown) return "👎";
  return "—";
}

export function getFeedbackColor(thumbsUp: boolean, thumbsDown: boolean): string {
  if (thumbsUp) return "text-green-600";
  if (thumbsDown) return "text-red-600";
  return "text-gray-400";
}

export function formatJSON(data: unknown): string {
  try {
    if (typeof data === "string") {
      return JSON.stringify(JSON.parse(data), null, 2);
    }
    return JSON.stringify(data, null, 2);
  } catch {
    return String(data);
  }
}
